import { Component } from '@angular/core';
import { ModalController, ViewController, Events } from 'ionic-angular';
import { LoginPage,HomePage } from "../../pages/dashboard";
/**
 * Generated class for the ForbidenloginComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'forbidenlogin',
  templateUrl: 'forbidenlogin.html'
})
export class ForbidenloginComponent {

  text: string;

  constructor(
    public viewCtrl : ViewController,
    public events : Events
  ) {
  }

  ionViewWillLeave(){
    this.events.publish('user:want_sign_out');
  }

  goMenu(menu){
    this.viewCtrl.dismiss(menu);
  }
}



// WEBPACK FOOTER //
// ./src/components/forbidenlogin/forbidenlogin.ts